import { Produktdaten } from '../../../../generated/model/produktdaten.model';
import { UmmeldungStore } from '../store';

export type UmmeldungStoreType = InstanceType<typeof UmmeldungStore>;

export interface UmmeldungWizardStartData {
  editableUmmeldungId?: string;
  produktdaten?: Produktdaten[];
}

export interface UmmeldungWizardNavigationState {
  ummeldungStart?: UmmeldungWizardStartData;
}

export function getUmmeldungWizardStartDataFromState(state: unknown): UmmeldungWizardStartData | null {
  if (!state || typeof state !== 'object') {
    return null;
  }

  const navigationState = state as UmmeldungWizardNavigationState;
  if (!navigationState.ummeldungStart) {
    return null;
  }

  return navigationState.ummeldungStart;
}
